import { createSlice } from "@reduxjs/toolkit"

const rolesSlice = createSlice({
  name: "roles",
  initialState: {
    rolesDetails: {},
    roles: [],
    loading: false,
    refetchData: false,
    refetchRoleData: false,
  },
  reducers: {
    getRolesListByFilters(state, action) {
      return {
        ...state,
        loading: true,
        refetchData: false,
        refetchRoleData: false,
      }
    },
    getRolesListByFiltersSuccess(state, { payload }) {
      return {
        ...state,
        loading: false,
        roles: payload.data.roles || [],
        total:
          payload.data.total && payload.data.total.value
            ? payload.data.total.value
            : payload.data.total
            ? payload.data.total
            : 0,
        refetchData: false,
        refetchRoleData: false,
      }
    },
    upsertRoles(state) {
      return {
        ...state,
        loading: false,
        refetchData: false,
      }
    },
    upsertRolesSuccess(state) {
      return {
        ...state,
        loading: false,
        refetchRoleData: true,
      }
    },
    deleteRoles(state) {
      return {
        ...state,
        loading: false,
        refetchData: false,
      }
    },
    deleteRolesSuccess(state) {
      return {
        ...state,
        loading: false,
        refetchRoleData: true,
      }
    },
    resetState() {
      return {
        rolesDetails: {},
        roles: [],
        loading: false,
        refetchData: false,
        refetchRoleData: false,
      }
    },
  },
})

export const {
  getRolesListByFilters,
  getRolesListByFiltersSuccess,
  upsertRoles,
  upsertRolesSuccess,
  deleteRoles,
  deleteRolesSuccess,
  resetState,
} = rolesSlice.actions

export default rolesSlice.reducer
